import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconModule } from '../../../common/icon/icon.module';
import { TruncateModule } from '../../truncate/truncate.module';
import { DividerModule } from './../../divider/divider.module';
import { DropdownItemComponent } from './dropdown-item.component';

@NgModule({
  declarations: [DropdownItemComponent],
  imports: [CommonModule, DividerModule, IconModule, DividerModule, TruncateModule],
  exports: [DropdownItemComponent],
})
export class DropdownItemModule {}
export { DropdownItemComponent } from './dropdown-item.component';
